<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="d-flex justify-content-between">
        <div class="section-title">
          {{ $t("cinema Tax Overall Analysis Report") }}
        </div>
        <div class="d-flex align-items-center">
          
          <div class="d-flex align-item-center">
                <input value="1" type="radio" v-model="lang_id">
                <span class="ml-1">English</span>
              </div>
              <div class="d-flex align-item-center ml-2">
              <input value="2" type="radio" v-model="lang_id">

              <span class="ml-1">العربية</span>
            </div>
        </div>
      </div>
      <small><em>{{ $t("* As Per Show Date") }}</em></small>

      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3 col-xl-3  mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.selectedCinema && dropDown.selectedCinema
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder=""
                @input="onSelectCinema($event)"
                :allowEmpty="true"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2  mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  selectedScreen && selectedScreen.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("All") }} {{ $t("screens") }}</label
              >
              <multiselect
                :options="screenList"
                v-model="selectedScreen"
                placeholder=""
                label="screen_name"
                :multiple="true"
                :close-on-select="false"
                track-by="screen_id"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2  mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                              ✖
                            </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                   @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2  mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                              ✖
                            </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                >
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>
      
            <!-- Show Time -->
                     <div class="position-relative col-lg-3 col-xl-2 mb-2">
                                           <vue-timepicker manual-input
                                            v-model="start_time"
                                             id="starttime"
                                             name="starttime"
                                             :placeholder="$tc('starttime')"
                                              format="HH:mm"
                                              class="time_picker"
                                              input-width="100%"
                                              auto-scroll
                                             lazy ></vue-timepicker>
                                         </div>
                              
                                 <div class="position-relative col-lg-3 col-xl-2 mb-2">
                         <vue-timepicker
                           manual-input
                           v-model="end_time"
                           id="endtime"
                           name="endtime"
                           :placeholder="$tc('endtime')"
                           format="HH:mm"
                           class="time_picker"
                           input-width="100%"
                           auto-scroll
                           lazy
                         />
                       </div>
                  <!-- Show Time -->

          <div class="col-12 col-md-6 col-lg-6 col-xl-2 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click="onSubmit">
              {{ $t("fetch") }}
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="screenData.length > 0"
        class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
      >
        <div class="mx-1">{{ $t("download") }} {{ $t("as") }}</div>
      
        <img
            @click="getCinemaOverallTaxAnalysisReport('Y','N')"
                class="cursor-pointer"
                height="25"
                src="@/assets/img/icons/pdf-icon.svg"
                width="25"
              />

              <img  @click="getCinemaOverallTaxAnalysisReport('N','Y')" class="cursor-pointer ml-1"
              height="25" src="@/assets/img/icons/excel.svg" width="25" />
      </div>

        <div
         class="swc-report"
        >
          <table
            class="swc-report-table swc_table_header"
            :class="lang_id==2?'swc-report-table reverse-order ':'swc-report-table order '"  
            border="1"
          >
            <thead class="bg-lightgrey">
              <tr>
                <th>{{ trans("screen",lang_id) }}</th>
                <th>{{ trans("showdate",lang_id)  }}</th>
                <th>{{ trans("ticketscount",lang_id) }}</th>
                <th>{{ trans("ticketscosttotal",lang_id) }}</th>
                <th>{{ trans("ticketscostforentry",lang_id) }}</th>
                <th>{{ trans("amusementtax",lang_id) }}</th>
                <th colspan="6">{{ trans("Additionalfees",lang_id) }}</th>
                <th>{{ trans("totaltax",lang_id) }}</th>
              </tr>
              <tr>
                <th colspan="6"></th>
                <th>{{ trans("socialsubside",lang_id) }}</th>
             <th>{{ trans("cinemasubside",lang_id) }}</th>
             <th>{{ trans("policesubside",lang_id) }}</th>
             <th>{{ trans("daransubside",lang_id) }}</th>
             <th>{{ trans("servicessubside",lang_id) }}</th>
             <th>{{ trans("sports",lang_id) }}</th>

             
                <th colspan="1"></th>
              </tr>
            </thead>
            <tbody v-if="screenData.length">
              <template v-for="screen in screenData">
                <!-- <tr class="bg-lightgrey">
                  <td class="text-left" colspan="13">{{ screen.screen_name }}</td>
                </tr> -->
                <template v-for="showDate in screen.screenData">

                <tr v-for="show in showDate.showDateData">
                  <td class="text-left">{{ screen.screen_name }}</td>
                  <td class="text-left">{{ moment(show.ss_start_date).format("YYYY-MM-DD") }}</td>
                  <td class="text-right">{{ show.tickets_no ||0}}</td>
                  <td class="text-right">
                    {{ parseFloat(show.tickets_gross ||0).toFixed(6) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.tickets_net || 0).toFixed(6) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.entertainment_tax ||0).toFixed(6) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.fixed_fees.social||0).toFixed(6) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.fixed_fees.cinema||0).toFixed(6) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.fixed_fees.police||0).toFixed(6) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.fixed_fees.daran||0).toFixed(6) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.fixed_fees.services||0).toFixed(6) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.fixed_fees.sports || 0).toFixed(6) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.total_tax ||0).toFixed(6) }}
                  </td>
                </tr>
              </template>
              <!-- <tr class="bg-lightgrey text-left">
                  <td colspan="2" :class="lang_id==1?'text-left':'text-right'">{{ trans("total",lang_id) }}</td>
                  <td class="text-right">{{ screen.grandTotal.tickets_no ||0 }}</td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.tickets_gross ||0).toFixed(6) ||
                      0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.tickets_net ||0).toFixed(6) ||
                      0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.entertainment_tax ||0).toFixed(
                        2
                      ) || 0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(screen.grandTotal.social||0).toFixed(6) || 0.0 }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(screen.grandTotal.cinema ||0).toFixed(6) || 0.0 }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(screen.grandTotal.police||0).toFixed(6) || 0.0 }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(screen.grandTotal.daran ||0).toFixed(6) || 0.0 }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.services || 0).toFixed(6) || 0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.sports ||0).toFixed(6) || 0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.total_tax).toFixed(6) || 0.0
                    }}
                  </td>
              
               
                </tr> -->
              </template>
              <tr class="bg-lightgrey text-right">
                <td colspan="2" :class="lang_id==1?'text-left':'text-right'">{{ trans("grandtotal",lang_id) }}</td>
                <td>{{ grandTotal.total_tickets_no ||0 }}</td>
                <td class="text-right">{{ parseFloat(grandTotal.total_tickets_gross ||0).toFixed(6) }}</td>
                <td class="text-right">{{ parseFloat(grandTotal.total_tickets_net ||0).toFixed(6) }}</td>
                <td class="text-right">
                  {{ parseFloat(grandTotal.total_entertainment_tax ||0).toFixed(6) }}
                </td>
                <td class="text-right">{{ parseFloat(grandTotal.social || 0 ).toFixed(6) }}</td>
                <td class="text-right">{{ parseFloat(grandTotal.cinema || 0 ).toFixed(6) }}</td>
                <td class="text-right">{{ parseFloat(grandTotal.police || 0 ).toFixed(6) }}</td>
                <td class="text-right">{{ parseFloat(grandTotal.daran || 0 ).toFixed(6) }}</td>
                <td class="text-right">{{ parseFloat(grandTotal.services || 0 ).toFixed(6) }}</td>
                <td class="text-right">{{ parseFloat(grandTotal.sports ||0).toFixed(6) }}</td>

                <td class="text-right">{{ parseFloat(grandTotal.total_tax || 0 ).toFixed(6) }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <td colspan="12">No Records</td>
            </tbody>
          </table>
        </div>
    </div>
  </div>
</template>
      
      <script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import NewReportService from "../../../services/NewReportService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";
import { mapState, mapActions } from "vuex";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  components: {
    NoRecords,
    VueTimepicker,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      start_time:"",
      end_time:"",
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 3,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape",
        },
      },
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
        selectedCineAddress:"",
      },
      fromDate: new Date(),
      toDate: new Date(),
      advancedSalesrecords: [],
      grandTotal: {},
      screenData: [],
      screenList: [],
      selectedScreen: [],
      selectedLanguage: "en",
      lang_id:"1"
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
  },
  watch: {},
  mounted() {},
  computed: {
    currentSelectedLanguage() {
      return this.$store.getters.GET_SELECTED_HEADER_LANGUAGE;
    },
  },
  methods: {
    moment,
      onChangeDate(e, type){
        if(type == 'from'){
          this.toDate = new Date(e);
          this.$forceUpdate();
        }
      },
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCineAddress = event.cine_address;
      // console.log("Selected Cinema Name:", this.dropDown.selectedCinemaName);
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
      this.getCinemaScreens();
    },
    async getCinemaOverallTaxAnalysisReport(isPdf = "N",isExcel="N") {
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader;
      try {
        let screen_id = [];
        this.screenData = [];
        if (this.selectedScreen.length) {
          screen_id = this.selectedScreen.map((screen) => screen.screen_id);
        }
        loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName,
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          screen_id,
          isPdf,
          isExcel,
          lang_id:this.lang_id,
          language: this.selectedLanguage,
          start_time:this.start_time,
          end_time:this.end_time,
          cinema_address:this.dropDown.selectedCineAddress,
           screen_name: this.selectedScreen.map(x =>x.screen_name),
           isReport: 'Y'
        };
        let response = await NewReportService.getCinemaTaxOverallAnalysisReport(
          payload
        );
        const { data } = response;
        if (data.status && data.Records.length) {
          this.screenData = data.Records;
          this.grandTotal = data.grandTotal;
          if (isPdf == "Y" && data.pdfPath) {
            window.open(data.pdfPath, "_blank");
          }
          if (isExcel == "Y" && data.excelPath) {
            window.open(data.excelPath, "_blank");
          }
        } else {
          this.$toasted.show(data.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (loader) {
          loader.hide();
        }
        MasterService;
      }
    },
    async getCinemaScreens(index) {
      try {
        const response = await MasterService.GetActiveList({
          tableName: "screens",
          screen_is_active: "Y",
          cinema_id: this.dropDown.selectedCinemaId,
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.screenList = data.Records;
        } else {
          console.log("show error:", data.message);
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    onSubmit() {
      this.getCinemaOverallTaxAnalysisReport();
    },
    updateLanguage(lang) {
      this.selectedLanguage = lang;
      // console.log("this.selectedLanguage:", this.selectedLanguage);
    },
  },
};
</script>
      
      <style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}

.swc-report-table th {
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}
.rtl-table {
  direction: rtl;
  text-align: right;
}
.rtl-table-scroll {
  direction: rtl;
}
.text_right{
  text-align: right;
}
.reverse-order{
  direction: rtl;
}
.order{
  direction: ltr
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/cinemaTaxOverAllanalysis.vue